import RootModel from './root';

const Step = new RootModel({
	path: 'steps',
});

export default Step;
